export const GET_BULK_WEIGHT_DISCREPANCY_DATA_SUCCESS = "GET_BULK_WEIGHT_DISCREPANCY_DATA_SUCCESS";
export const GET_BULK_WEIGHT_DISCREPANCY_DATA_REQUEST = "GET_BULK_WEIGHT_DISCREPANCY_DATA_REQUEST";
export const GET_BULK_WEIGHT_DISCREPANCY_DATA_FAILURE = "GET_BULK_WEIGHT_DISCREPANCY_DATA_FAILURE";
export const GET_BULK_WEIGHT_DISCREPANCY_DATA_RESET = "GET_BULK_WEIGHT_DISCREPANCY_DATA_RESET";
export const getBulkWeightDiscrepancyDataSuccess = (payload) => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_DATA_SUCCESS,
    payload,
});
export const getBulkWeightDiscrepancyDataRequest = (payload) => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_DATA_REQUEST,
    payload,
});
export const getBulkWeightDiscrepancyDataFailure = (payload) => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_DATA_FAILURE,
    payload,
});
export const getBulkWeightDiscrepancyDataReset = () => ({
    type: GET_BULK_WEIGHT_DISCREPANCY_DATA_RESET,
});
